export enum AuxiliaryMaterialType {
  Weblink = 'WEBLINK',
  Video = 'VIDEO',
  Audio = 'AUDIO',
  Epub = 'EPUB'
}
